const imagesLoaded = require('imagesloaded')
export function useImageMasonryWithLazyLoad() {
    document.addEventListener("DOMContentLoaded", function() {
        var lazyloadImages;    
    
        if ("IntersectionObserver" in window) {
            lazyloadImages = document.querySelectorAll(".lazy");
            var imageObserver = new IntersectionObserver(function(entries, observer) {
                entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                    var image = entry.target;
                    
                    image.src = image.dataset.src;
                    image.classList.remove("lazy");
                    
                    imageObserver.unobserve(image);
                    imagesLoaded(image.parentElement, function(instance) {
                        let item = instance.elements[0];
                        /* Get the grid object, its row-gap, and the size of its implicit rows */
                        let grid = document.getElementsByClassName('image-group-masonry')[0],
                        rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap')),
                        rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'))
                        /*
                        * Spanning for any brick = S
                        * Grid's row-gap = G
                        * Size of grid's implicitly create row-track = R
                        * Height of item content = H
                        * Net height of the item = H1 = H + G
                        * Net height of the implicit row-track = T = G + R
                        * S = H1 / T
                        */
                        let rowSpan = Math.ceil((item.querySelector('.masonry-content').getBoundingClientRect().height+rowGap)/(rowHeight+rowGap))
                    
                        /* Set the spanning as calculated above (S) */
                        item.style.gridRowEnd = 'span '+rowSpan;
                    })
                }
                });
            });
    
            lazyloadImages.forEach(function(image) {
                imageObserver.observe(image);
            });
        } else {  
            var lazyloadThrottleTimeout;
            lazyloadImages = document.querySelectorAll(".lazy");
            
            function lazyload () {
                console.log('testsss')
                if(lazyloadThrottleTimeout) {
                clearTimeout(lazyloadThrottleTimeout);
                }    
        
                lazyloadThrottleTimeout = setTimeout(function() {
                var scrollTop = window.pageYOffset;
                lazyloadImages.forEach(function(img) {
                    if(img.offsetTop < (window.innerHeight + scrollTop)) {
                        img.src = img.dataset.src;
                        img.classList.remove('lazy');
                    }
                });
                if(lazyloadImages.length == 0) { 
                    document.removeEventListener("scroll", lazyload);
                    window.removeEventListener("resize", lazyload);
                    window.removeEventListener("orientationChange", lazyload);
                }
                }, 20);
            }
        
            document.addEventListener("scroll", lazyload);
            window.addEventListener("resize", lazyload);
            window.addEventListener("orientationChange", lazyload);
        }
    })
}

export function useImageMasonry() {
    let allItems = document.getElementsByClassName('masonry-brick');
    for (let i=0; i < allItems.length; i++) {
        imagesLoaded(allItems[i], function(instance) {
            let item = instance.elements[0];
            /* Get the grid object, its row-gap, and the size of its implicit rows */
            let grid = document.getElementsByClassName('image-group-masonry')[0],
            rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap')),
            rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'))
            /*
            * Spanning for any brick = S
            * Grid's row-gap = G
            * Size of grid's implicitly create row-track = R
            * Height of item content = H
            * Net height of the item = H1 = H + G
            * Net height of the implicit row-track = T = G + R
            * S = H1 / T
            */
            let rowSpan = Math.ceil((item.querySelector('.masonry-content').getBoundingClientRect().height+rowGap)/(rowHeight+rowGap))
        
            /* Set the spanning as calculated above (S) */
            item.style.gridRowEnd = 'span '+rowSpan;
            // console.log(item)
        })
    }
}